import React from 'react'
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  IconButton,
  Typography
} from '@material-ui/core'
import classNames from 'classnames'
import { Close, CheckBoxOutlineBlank } from '@material-ui/icons'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import mobileView from '../mobile.utils'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import { useSelector } from 'react-redux'
import { getLocaleByLang } from '../../form/components/inputs'
import { CalendarIcon } from '@mui/x-date-pickers'

const filterFieldStyle = { padding: '0 8px', width: mobileView ? '' : '200px' }
const labelStyle = { fontSize: '18px', marginTop: '22px' }

export const WorkshiftFilters = ({
  t,
  filters,
  onChange,
  classes,
  statusOptions = [{ value: '', label: '' }],
  resetSelectedPage
}) => {
  const [open, setOpen] = React.useState(false)
  const handleChange = (field) => (e) => {
    resetSelectedPage()
    onChange({
      ...filters,
      [field]: e.target?.type === 'checkbox' ? e.target.checked : e.target.value
    })
  }

  const lang = useSelector((state) => state.language.lang)
  const locale = React.useMemo(() => getLocaleByLang(lang), [lang]) // Dynamically set locale

  return (
    <div className={classNames(classes.searchField)}>
      <div
        className={classNames(classes.filterFields)}
        style={mobileView ? { paddingBottom: 0 } : {}}
      >
        {/*Name*/}
        <div style={filterFieldStyle}>
          <TextField
            label={t('employer.workshifts.col2')}
            value={filters.name}
            onChange={handleChange('name')}
            InputProps={{
              classes: { input: classNames(classes.textField, classes.resize) }
            }}
            InputLabelProps={{ shrink: true, style: labelStyle }}
          />
        </div>

        {/*Email*/}
        <div style={filterFieldStyle}>
          <TextField
            label={t('employer.workshifts.col15')}
            value={filters.email}
            onChange={handleChange('email')}
            InputProps={{
              classes: { input: classNames(classes.textField, classes.resize) }
            }}
            InputLabelProps={{ shrink: true, style: labelStyle }}
          />
        </div>

        {/*Date*/}
        <div style={filterFieldStyle}>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
            <DatePicker
              open={open}
              onOpen={() => setOpen(true)}
              value={filters.workshift_date}
              onChange={(date) => {
                resetSelectedPage()
                onChange({
                  ...filters,
                  workshift_date: date
                })
              }}
              label={
                <Typography style={{ fontSize: '13px', fontWeight: 500 }}>
                  {t('employer.workshifts.col3')}
                </Typography>
              }
              onClose={() => {
                setOpen(false)
              }}
              InputLabelProps={{
                shrink: false, // <-- this keeps the label inside
                style: {
                  fontSize: '13px',
                  marginTop: '-3px'
                }
              }}
              InputProps={{
                classes: {
                  input: classNames(classes.textField)
                }
              }}
              format={'dd.MM.yyyy'}
            />
          </MuiPickersUtilsProvider>
          {filters.workshift_date === null ? (
            <IconButton
              className={classes.clearFieldButton}
              onClick={() => {
                setOpen(true)
              }}
              style={{ color: '#44C0CC' }}
            >
              <CalendarIcon className={classes.clearIcon} />
            </IconButton>
          ) : (
            <IconButton
              className={classes.clearFieldButton}
              onClick={() => {
                resetSelectedPage()
                onChange({
                  ...filters,
                  workshift_date: null
                })
              }}
            >
              <Close className={classes.clearIcon} />
            </IconButton>
          )}
        </div>

        {/* Status */}
        <div style={filterFieldStyle}>
          <FormControl
            fullWidth
            style={{ marginTop: mobileView ? '32px' : '' }}
          >
            <InputLabel shrink style={{ fontSize: '18px', marginTop: '-2px' }}>
              {t('employer.workshifts.col8')}
            </InputLabel>
            <Select
              value={filters.status}
              onChange={handleChange('status')}
              className={classNames(classes.textField)}
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {t(option.label)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        {/* Pinned Checkbox */}
        <div style={{ padding: '0 8px' }}>
          <FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  icon={<CheckBoxOutlineBlank fontSize="large" />}
                  checkedIcon={
                    <CheckBoxIcon
                      fontSize="large"
                      style={{ fill: '#F67131' }}
                    />
                  }
                  checked={filters.pinned}
                  onChange={handleChange('pinned')}
                />
              }
              label={
                <Typography style={{ fontSize: '13px', fontWeight: 500 }}>
                  {t('employer.app.fld18')}
                </Typography>
              }
              className={classes.checkbox}
              style={{ marginBottom: 0 }}
            />
          </FormControl>
        </div>
      </div>
      <div className={classNames(classes.filterFields)}>
        {/* Page Size */}
        <div style={{ padding: '0 8px', width: '80px' }}>
          <FormControl fullWidth>
            <InputLabel shrink style={{ fontSize: '18px', marginTop: '-2px' }}>
              {t('employer.app.fld17')}
            </InputLabel>
            <Select
              value={filters.pageSize}
              onChange={handleChange('pageSize')}
              className={classNames(classes.textField)}
            >
              {[10, 20, 50, 100].map((size) => (
                <MenuItem key={size} value={size}>
                  {size}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      </div>
    </div>
  )
}
